export const environment = {
  production: (window as any).env?.production ?? false,
  maintenance: (window as any).env?.maintenance ?? false,
  apiURL: (window as any).env?.apiURL ?? "https://localhost:7117",
  ClientAppSettings: {
    gaBarUrl: (window as any).env?.ClientAppSettings?.gaBarUrl ?? 'https://dev.gabar.org'
  },
  AuthSettings: {
    cleAPI: {
      endpoint: (window as any).env?.AuthSettings?.cleAPI?.endpoint ?? 'https://localhost:7117/cle',
      scopes: {
          read: (window as any).env?.AuthSettings?.cleAPI?.scopes?.read ?? ['api://5e19a916-9eb9-427a-8a85-5880605739b9/CLE.SponsorPortal.Access'],
          write: (window as any).env?.AuthSettings?.cleAPI?.scopes?.write ?? ['api://5e19a916-9eb9-427a-8a85-5880605739b9/CLE.SponsorPortal.Access'],
      },
    },
    newCourseAPI: {
      endpoint: (window as any).env?.AuthSettings?.newCourseAPI?.endpoint ?? 'https://localhost:7117/cle/NewCourse',
      scopes: {
          read: (window as any).env?.AuthSettings?.newCourseAPI?.scopes?.read ?? ['api://5e19a916-9eb9-427a-8a85-5880605739b9/CLE.SponsorPortal.Access'],
          write: (window as any).env?.AuthSettings?.newCourseAPI?.scopes?.write ?? ['api://5e19a916-9eb9-427a-8a85-5880605739b9/CLE.SponsorPortal.Access'],
      },
    },
    newCoursesAPI: {
      endpoint: (window as any).env?.AuthSettings?.newCoursesAPI?.endpoint ?? 'https://localhost:7117/cle/newcourses',
      scopes: {
          read: (window as any).env?.AuthSettings?.newCoursesAPI?.scopes?.read ?? ['api://5e19a916-9eb9-427a-8a85-5880605739b9/CLE.SponsorPortal.Access'],
          write: (window as any).env?.AuthSettings?.newCoursesAPI?.scopes?.write ?? ['api://5e19a916-9eb9-427a-8a85-5880605739b9/CLE.SponsorPortal.Access'],
      },
    },
  },
};